import { Avatar, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import React from "react";


const Message = ({ message, type }) => {


  const avatar = message.djag ? 
    <Avatar alt={message.from} src={require('../assets/paradise_transparent.png')} />
    :
    <Avatar>{message.from.split(" ").map(l=>l.substring(0,1))}</Avatar>;

    return (
        <ListItem alignItems="flex-start">
        <ListItemAvatar>{avatar}</ListItemAvatar>
        <ListItemText
          primary={<React.Fragment>
            {message.from}
            <Typography
              component="span"
              variant="body2"
              sx={{ color: 'text.primary', display: 'inline' }}
            > {message.sent}</Typography> 
          </React.Fragment>}
          secondary={message.message}
        />
      </ListItem>
    );
}

export default Message;